(() => {
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:window.Shopify?.currency?.active || 'AUD'}).format(value / 100);
  const root = () => window.Shopify?.routes?.root || '/';
  function revealPanel(panel, open) {
    const wasHidden = panel.hidden;
    const current = getComputedStyle(panel);
    const height = wasHidden ? 0 : panel.getBoundingClientRect().height;
    const opacity = wasHidden ? 0 : Number(current.opacity);
    const marginTop = wasHidden ? '0px' : current.marginTop;
    const marginBottom = wasHidden ? '0px' : current.marginBottom;
    const edges = ['paddingTop','paddingBottom','borderTopWidth','borderBottomWidth'];
    const startEdges = Object.fromEntries(edges.map(key => [key, wasHidden ? '0px' : current[key]]));
    panel.revealAnimation?.cancel();
    panel.hidden = false;
    panel.inert = !open;
    const natural = getComputedStyle(panel);
    const target = panel.getBoundingClientRect().height;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      panel.hidden = !open;
      panel.revealAnimation = null;
      return Promise.resolve(true);
    }
    const animation = panel.animate([
      {...startEdges, height:height+'px', opacity, marginTop, marginBottom, overflow:'hidden', minHeight:0},
      {...Object.fromEntries(edges.map(key => [key, open ? natural[key] : '0px'])), height:open ? target+'px' : '0px', opacity:open ? 1 : 0, marginTop:open ? natural.marginTop : '0px', marginBottom:open ? natural.marginBottom : '0px', overflow:'hidden', minHeight:0}
    ], {duration:250, easing:'ease', fill:'both'});
    panel.revealAnimation = animation;
    return animation.finished.then(() => {
      panel.hidden = !open;
      animation.cancel();
      panel.revealAnimation = null;
      return true;
    }).catch(() => false);
  }
  async function add(formData) {
    const response = await fetch(`${root()}cart/add.js`, {method:'POST', body:formData, headers:{'X-Requested-With':'XMLHttpRequest'}});
    let result;
    try {result=await response.json();}
    catch {throw new Error('Connection interrupted. Please try again.');}
    if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return result;
  }
  class MountFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.infoId = `mount-info-${Math.random().toString(36).slice(2)}`;
      this.catalogue = JSON.parse(this.querySelector('[data-mount-catalogue]').textContent);
      this.brand = this.querySelector('[data-mount-brand]');
      this.model = this.querySelector('[data-mount-model]');
      const brands = new Map();
      this.catalogue.forEach(item => {
        item.brands.forEach(brand => brands.set(brand.id,brand.name));
        item.models.forEach(model => brands.set(model.brand,model.brandName));
      });
      [...brands].filter(([id,name])=>id&&name).sort((a,b)=>a[1].localeCompare(b[1])).forEach(([id,name])=>this.brand.add(new Option(name,id)));
      this.classList.add('is-enhanced');
      [this.brand,this.model].forEach((select,index)=>{
        const field=select.parentElement;
        const button=document.createElement('button');button.type='button';button.className='pdp-mount__select';button.setAttribute('aria-haspopup','listbox');button.setAttribute('aria-expanded','false');button.setAttribute('aria-label',select.getAttribute('aria-label'));
        const list=document.createElement('div');list.className='pdp-mount__list';list.hidden=true;list.setAttribute('role','listbox');list.setAttribute('aria-label',select.getAttribute('aria-label'));list.id=`mount-list-${index}-${Math.random().toString(36).slice(2)}`;button.setAttribute('aria-controls',list.id);
        field.append(button);field.after(list);select.picker={button,list};
        button.addEventListener('click',event=>{event.preventDefault();const open=button.getAttribute('aria-expanded')!=='true';this.closeLists(select);button.setAttribute('aria-expanded',String(open));revealPanel(list,open);if(open)list.querySelector('[aria-selected=true],button')?.focus({preventScroll:true});});
        list.addEventListener('keydown',event=>{
          const options=[...list.querySelectorAll('button')];const active=options.indexOf(document.activeElement);let next;
          if(event.key==='ArrowDown')next=(active+1)%options.length;
          if(event.key==='ArrowUp')next=(active-1+options.length)%options.length;
          if(event.key==='Home')next=0;if(event.key==='End')next=options.length-1;
          if(next!==undefined){event.preventDefault();options[next]?.focus();}
          if(event.key==='Escape'){event.preventDefault();event.stopPropagation();this.closeLists();button.focus();}
        });
      });
      this.updatePickers();
      this.addEventListener('click', async event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-mount-toggle')) this.toggle();
        if (button.hasAttribute('data-mount-clear')) {this.brand.value=''; this.changeBrand(); this.brand.picker.button.focus();}
        if (button.hasAttribute('data-mount-add')) await this.addMount(button);
      });
      this.brand.addEventListener('change',()=>this.changeBrand());
      this.model.addEventListener('change',()=>{this.results();this.updatePickers();});
      this.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.classList.contains('is-open')) {this.toggle(); this.querySelector('[data-mount-toggle]').focus();}});
    }
    closeLists(except){[this.brand,this.model].filter(select=>select!==except).forEach(select=>{if(select.picker.button.getAttribute('aria-expanded')==='true')revealPanel(select.picker.list,false);select.picker.button.setAttribute('aria-expanded','false');});}
    updatePickers(){
      [this.brand,this.model].forEach(select=>{
        const {button,list}=select.picker;button.textContent=select.selectedOptions[0]?.textContent||'Select';button.disabled=select.disabled;
        const arrow=document.createElement('img');arrow.src=this.querySelector('[data-mount-toggle] img').src.replace(/interaction-(?:close|chevron-dark)\.svg/,'interaction-chevron-white.svg');arrow.width=12;arrow.height=12;arrow.alt='';button.append(arrow);
        list.replaceChildren();[...select.options].filter(option=>option.value).forEach(option=>{
          const item=document.createElement('button');item.type='button';item.textContent=option.textContent;item.setAttribute('role','option');item.setAttribute('aria-selected',String(option.selected));
          item.addEventListener('click',()=>{select.value=option.value;this.closeLists();select.dispatchEvent(new Event('change',{bubbles:true}));button.focus();});list.append(item);
        });
      });
    }
    toggle() {
      this.querySelectorAll('pdp-info-popover:popover-open').forEach(popover=>popover.hidePopover());
      const open=this.classList.toggle('is-open');
      const toggle=this.querySelector('[data-mount-toggle]');
      toggle.setAttribute('aria-expanded',String(open));
      toggle.setAttribute('aria-label',open?'Close mount finder':'Open mount finder');
      const image=toggle.querySelector('img');
      if (!this.closedImage) this.closedImage=image.src;
      image.src=open?this.closedImage.replace('interaction-chevron-dark.svg','interaction-close.svg'):this.closedImage;
      this.classList.toggle('is-closing', !open);
      revealPanel(this.querySelector('[data-mount-body]'), open).then(finished => {
        if (finished && !this.classList.contains('is-open')) this.classList.remove('is-closing');
      });
      this.closeLists();
      if(open&&this.brand.options.length<2) this.error('Mount information is temporarily unavailable. Please contact us for help.');
    }
    changeBrand() {
      this.model.replaceChildren(new Option('Select model',''));
      const models=new Map();
      this.catalogue.forEach(item=>item.models.filter(model=>model.brand===this.brand.value).forEach(model=>models.set(model.id,model.name)));
      [...models].sort((a,b)=>a[1].localeCompare(b[1])).forEach(([id,name])=>this.model.add(new Option(name,id)));
      const wholeBrand=this.catalogue.some(item=>!item.models.length&&item.brands.some(brand=>brand.id===this.brand.value));
      if(wholeBrand) this.model.add(new Option('All models', '*'));
      this.model.disabled=!this.brand.value || this.model.options.length<2;
      this.querySelector('[data-mount-added]').hidden=true;
      this.querySelector('[data-mount-search]').hidden=false;
      this.error('');
      this.results();
      this.updatePickers();
    }
    error(message) {const field=this.querySelector('[role=alert]'); field.textContent=message; field.hidden=!message;}
    results() {
      const matches=this.catalogue.filter(item=>this.model.value && (item.models.some(model=>model.brand===this.brand.value&&model.id===this.model.value) || (!item.models.length&&item.brands.some(brand=>brand.id===this.brand.value))));
      const info=this.querySelector('[data-mount-toggle] img').src.replace(/interaction-(?:close|chevron-dark)\.svg/,'interaction-info.svg');
      const bike=[this.brand.selectedOptions[0]?.textContent,this.model.value==='*'?'':this.model.selectedOptions[0]?.textContent].filter(Boolean).join(' ');
      this.querySelector('[data-mount-results]').innerHTML=matches.map(item=>{
        const id=`${this.infoId}-${item.id}`;
        const description=document.createElement('textarea');
        description.innerHTML=item.description||'';
        return `<div class="pdp-mount__result"><p>MATCHING MOUNT</p><div class="pdp-interaction__product"><img src="${escape(item.image)}" alt="" width="60" height="60"><div><p class="pdp-interaction__title">${escape(item.title)}</p><p class="pdp-interaction__price">${money(item.price)}</p></div><button type="button" class="pdp-interaction__icon" popovertarget="${id}" aria-haspopup="dialog" aria-expanded="false" aria-label="Details for ${escape(item.title)}"><img src="${escape(info)}" width="34" height="34" alt=""></button></div><pdp-info-popover id="${id}" class="pdp-info-popover" popover role="dialog" aria-labelledby="${id}-title"><h3 id="${id}-title">${escape(item.title)}</h3><button type="button" data-popover-close aria-label="Close mount information">×</button>${description.value?`<p>${escape(description.value)}</p>`:''}<p><strong>Bike compatibility</strong><br>${escape(bike)}</p></pdp-info-popover><button type="button" class="pdp-interaction__cta" data-mount-add="${item.id}" ${item.available?'':'disabled'}>${item.available?'ADD TO CART':'SOLD OUT'}</button></div>`;
      }).join('');
      if(this.brand.value&&this.model.options.length<2) this.error('No model information is available for this brand. Contact us to confirm fitment.');
      else if(this.model.value&&!matches.length) this.error('No matching mount found. Contact us for help choosing a mount.');
    }
    async addMount(button) {
      if(this.pending) return;
      const item=this.catalogue.find(item=>String(item.id)===button.dataset.mountAdd);
      if(!item?.available) return;
      this.pending=true; button.disabled=true; button.textContent='ADDING…'; this.error('');
      try {
        const data=new FormData(); data.set('id',item.id); data.set('quantity','1'); await add(data);
        this.querySelectorAll('pdp-info-popover:popover-open').forEach(popover=>popover.hidePopover());
        this.querySelector('[data-mount-search]').hidden=true;
        this.querySelector('[data-mount-added]').hidden=false;
        this.querySelector('[data-added-title]').textContent=item.title;
        this.querySelector('[data-mount-added] a').focus({preventScroll:true});
      } catch(error) {this.error(error.message || 'Connection failed. Please try again.');}
      finally {this.pending=false; button.disabled=false; button.textContent='ADD TO CART';}
    }
  }
  if(!customElements.get('pdp-mount-finder')) customElements.define('pdp-mount-finder',MountFinder);
  class MobileSelector extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true; this.state='default'; this.previous='default';
      this.catalogue=JSON.parse(this.querySelector('[data-float-catalogue]').textContent);
      this.abort=new AbortController();
      this.addEventListener('click',event=>this.click(event),{signal:this.abort.signal});
      this.addEventListener('keydown',event=>{if(event.key==='Escape'){this.show('default',true);}},{signal:this.abort.signal});
      document.addEventListener('focusin',event=>{this.hadFocus=this.contains(event.target);},{signal:this.abort.signal});
      document.addEventListener('pointerdown',event=>{if(!this.contains(event.target))this.hadFocus=false;},{signal:this.abort.signal});
      this.hero=document.querySelector('.shopify-section--pdp-v2 product-rerender');
      this.observer=new MutationObserver(()=>this.schedule());
      this.observer.observe(this.hero,{childList:true,subtree:true});
      this.hero.addEventListener('change',()=>this.schedule(),{signal:this.abort.signal});
      this.sync();
      this.observePurchase();
      const updateVisibility=()=>{if(this.purchase){this.purchaseAbove=this.purchase.getBoundingClientRect().bottom<=0;if(innerWidth>=1000&&this.state!=='default')this.show('default');else this.visibility();}};
      window.addEventListener('scroll',updateVisibility,{passive:true,signal:this.abort.signal});
      window.addEventListener('resize',updateVisibility,{passive:true,signal:this.abort.signal});
      try {
        const saved=JSON.parse(sessionStorage.getItem('pdp-selector-state')||'null');
        sessionStorage.removeItem('pdp-selector-state');
        if(saved&&saved.path===location.pathname&&Date.now()-saved.time<60000) {
          this.previous=saved.previous||'default';
          this.show(saved.state, true); this.restoring=true;
          // Options differ in height (bundle tiles), so restore the purchase block's bottom edge rather than the raw
          // offset; a taller option would otherwise leave the block on screen and hide the bar.
          requestAnimationFrame(()=>{const bottom=this.purchase?.getBoundingClientRect().bottom;window.scrollTo({top:typeof saved.bottom==='number'&&typeof bottom==='number'?scrollY+bottom-saved.bottom:saved.scroll,behavior:'instant'});if(this.purchase)this.purchaseAbove=this.purchase.getBoundingClientRect().bottom<=0;this.restoring=false;this.visibility();});
        }
      } catch {}
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.purchaseObserver?.disconnect();clearTimeout(this.timer);}
    schedule(){clearTimeout(this.timer);this.timer=setTimeout(()=>{this.sync();this.observePurchase();},50);}
    observePurchase(){
      const purchase=document.querySelector('.shopify-section--pdp-v2');
      if(this.purchase===purchase) return;
      this.purchase=purchase; this.purchaseObserver?.disconnect();
      this.purchaseObserver=new IntersectionObserver(entries=>{this.purchaseAbove=entries[0].boundingClientRect.bottom<=0; this.visibility();});
      if(purchase) this.purchaseObserver.observe(purchase);
    }
    visibility(){
      const visible=innerWidth<1000&&!!(this.purchaseAbove||this.restoring);
      this.hidden=false;
      this.inert=!visible;
      this.classList.toggle('is-visible',visible);
      if(!visible&&this.hadFocus)this.focusHero();
    }
    focusHero(){
      const control=this.selected?.matches('a,button')?this.selected:[...this.form?.elements||[]].find(element=>element.type==='submit'&&element.getClientRects().length);
      this.hadFocus=false;
      control?.focus();
    }
    focusControl(selector){
      const control=this.querySelector(selector);
      if(control?.getClientRects().length)control.focus({preventScroll:true});
      else this.focusHero();
    }
    sync(){
      const focused=document.activeElement;
      const focusKey=this.contains(focused)?['choice','choiceInfo','colour'].find(key=>focused.dataset[key]!==undefined):null;
      const focusValue=focusKey?focused.dataset[focusKey]:null;
      this.form=document.getElementById(this.dataset.form);
      if(!this.form) return;
      this.cards=[...document.querySelectorAll('.product-info .variant-card-row')];
      const id=this.form.querySelector('[name=id]')?.value;
      this.current=this.catalogue.find(item=>String(item.id)===id);
      this.selected=this.cards.find(card=>card.classList.contains('is-selected')) || this.cards.find(card=>card.control?.checked) || this.cards[0];
      if(!this.selected) return;
      this.title=this.selected.querySelector('.variant-card-row__title')?.textContent.trim() || this.current?.name || '';
      this.image=this.selected.querySelector('img')?.src || '';
      this.priceHTML=this.selected.querySelector('.variant-card-row__prices')?.innerHTML || '';
      this.querySelector('[data-float-title]').textContent=this.title;
      this.querySelector('[data-float-image]').src=this.image;
      this.querySelector('[data-float-price]').innerHTML=this.priceHTML;
      this.querySelector('[data-detail-title]').textContent=this.title;
      this.querySelector('[data-detail-price]').innerHTML=this.priceHTML;
      const choices=this.querySelector('[data-float-choices]');
      choices.replaceChildren();
      // Grouped picker (pdp-v2-option-groups): repeat its heading before the first card after the standalone group.
      const groupHeading=document.querySelector('.product-info .pdp-v2-option-heading')?.textContent.trim();
      const standaloneCount=document.querySelectorAll('.product-info .pdp-v2-option-group--single .variant-card-row').length;
      this.cards.forEach((card,index)=>{
        if(groupHeading&&standaloneCount&&index===standaloneCount){const divider=document.createElement('p');divider.className='pdp-float__group';divider.textContent=groupHeading;choices.append(divider);}
        const row=document.createElement('div'); row.className=`pdp-float__option${card===this.selected?' is-selected':''}`;
        const choice=document.createElement('button');choice.type='button';choice.dataset.choice=String(index);choice.setAttribute('aria-pressed',String(card===this.selected));choice.disabled=card.classList.contains('is-disabled');
        const title=card.querySelector('.variant-card-row__title')?.textContent.trim()||'';
        choice.innerHTML=`<span class="pdp-interaction__product"><img width="60" height="60" src="${escape(card.querySelector('img')?.src)}" alt=""><span><span class="pdp-interaction__title">${escape(title)}</span><span class="pdp-interaction__price" style="display:block">${card.querySelector('.variant-card-row__prices')?.innerHTML||''}</span>${card.querySelector('.variant-card-row__badge')?.outerHTML||''}</span></span>`;
        const info=this.querySelector('[data-float-info]').cloneNode(true);info.removeAttribute('data-float-info');info.dataset.choiceInfo=String(index);info.setAttribute('aria-label',`Details for ${title}`);
        row.append(choice,info);choices.append(row);
      });
      const items=this.current?.components?.length?this.current.components:this.current?.inclusions||[];
      this.querySelector('[data-detail-bullets]').innerHTML=items.map(item=>`<li>${escape(item.name)}</li>`).join('');
      const inclusions=[...(this.current?.inclusions||[])];
      items.forEach(item=>{if(!inclusions.some(other=>other.name===item.name)) inclusions.push(item);});
      this.querySelector('[data-detail-inclusions]').innerHTML=inclusions.map(item=>`<div>${item.image?`<img src="${escape(item.image)}" width="108" height="108" alt="">`:''}<span>${escape(item.name)}</span></div>`).join('');
      this.colourGroups=[...document.querySelectorAll('.pdp-bundle-configuration .bundle-inclusions__swatch-group')];
      this.renderColours();
      this.querySelectorAll('[data-float-add]').forEach(button=>button.disabled=this.pending||!!this.form.querySelector('button[type=submit]')?.disabled);
      this.show(this.state);
      if(focusKey) this.querySelectorAll('button').forEach(button=>{if(button.dataset[focusKey]===focusValue) button.focus({preventScroll:true});});
    }
    renderColours(){
      const container=this.querySelector('[data-colour-content]'); container.replaceChildren();
      this.colourGroups.forEach((group,groupIndex)=>{
        const product=group.closest('.horizontal-product');
        const row=document.createElement('div');row.className='pdp-float__colour-row';
        const image=product.querySelector('img')?.cloneNode();if(image) row.append(image);
        const content=document.createElement('div');
        const title=document.createElement('p');title.textContent=product.querySelector('.bold')?.textContent.trim()||'Case colour';title.style.fontSize='16px';content.append(title);
        const swatches=document.createElement('div');swatches.className='pdp-float__swatches';
        [...group.querySelectorAll('input[type=radio]')].forEach((input,index)=>{
          const label=group.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          const button=document.createElement('button');button.type='button';button.dataset.colour=`${groupIndex}:${index}`;button.setAttribute('aria-label',label?.textContent.trim()||'Case colour');button.setAttribute('aria-pressed',String(input.checked));button.disabled=input.disabled||!!label?.classList.contains('is-disabled');
          const swatch=document.createElement('span');swatch.className='color-swatch';swatch.style.cssText=label?.getAttribute('style')||'';button.append(swatch);swatches.append(button);
        });
        content.append(swatches); const name=document.createElement('p');name.className='pdp-float__colour-name';name.textContent=group.querySelector('input:checked')?.nextElementSibling?.textContent.trim()||'';content.append(name);row.append(content);container.append(row);
      });
    }
    show(state, focus=false){
      this.state=state;
      ['default','options','details','added'].forEach(name=>this.querySelector(`[data-float-${name}]`).hidden=name!==state);
      this.querySelector('[data-float-main]').hidden=state==='added';
      const colour=state==='options'&&!this.colourDismissed&&this.colourGroups?.length>0;
      this.querySelector('[data-float-colour]').hidden=!colour;
      this.querySelector('[data-float-main] [data-float-add]').hidden=colour;
      this.querySelector('[data-float-expand]').setAttribute('aria-expanded',String(state==='options'));
      this.visibility();
      if(focus) {
        const target=state==='options'?'[data-choice][aria-pressed="true"]':state==='details'?'[data-float-back]':state==='added'?'[data-float-added] a':'[data-float-expand]';
        this.focusControl(target);
      }
    }
    select(index,state){
      this.colourDismissed=false;
      const card=this.cards[index];if(!card||card.classList.contains('is-disabled')) return;
      if(card===this.selected){this.show(state,true);return;}
      if(card.tagName==='A') {
        // Keyed to the destination: on a child product the choice opens its sibling product, not this one.
        try {sessionStorage.setItem('pdp-selector-state',JSON.stringify({path:new URL(card.href,location.href).pathname,scroll:scrollY,bottom:this.purchase?.getBoundingClientRect().bottom,state,previous:this.previous,time:Date.now()}));}catch{}
        card.click();
      } else {card.click();this.show(state,true);}
    }
    click(event){
      const button=event.target.closest('button');if(!button||this.pending) return;
      if(button.hasAttribute('data-float-expand')) { this.colourDismissed=false; this.show('options',true); }
      if(button.hasAttribute('data-float-collapse')) this.show('default',true);
      if(button.hasAttribute('data-colour-close')) { this.colourDismissed=true; this.show('options',true); }
      if(button.hasAttribute('data-float-info')) {this.previous=this.state;this.show('details',true);}
      if(button.hasAttribute('data-float-back')) {
        this.show(this.previous,true);
        if(this.previous==='default') this.focusControl('[data-float-info]');
      }
      if(button.hasAttribute('data-choice')) this.select(Number(button.dataset.choice),'options');
      if(button.hasAttribute('data-choice-info')) {this.previous='options';this.select(Number(button.dataset.choiceInfo),'details');}
      if(button.hasAttribute('data-colour')) {
        const [group,index]=button.dataset.colour.split(':').map(Number);
        const input=this.colourGroups[group].querySelectorAll('input[type=radio]')[index];
        input.click();this.renderColours();this.querySelector(`[data-colour="${group}:${index}"]`)?.focus({preventScroll:true});
      }
      if(button.hasAttribute('data-float-add')) this.submit();
    }
    async submit(){
      if(this.pending||!this.form||!this.form.reportValidity()) return;
      this.pending=true;const error=this.querySelector('[role=alert]');error.hidden=true;
      this.querySelectorAll('[data-float-add]').forEach(button=>{button.disabled=true;button.textContent='ADDING…';});
      try {
        await add(new FormData(this.form));
        this.querySelector('[data-float-added-title]').textContent=this.title;
        this.show('added');this.querySelector('[data-float-added] a').focus({preventScroll:true});
      } catch(reason) {error.textContent=reason.message||'Connection failed. Please try again.';error.hidden=false;}
      finally {this.pending=false;this.querySelectorAll('[data-float-add]').forEach(button=>{button.disabled=false;button.textContent='ADD TO CART';});}
    }
  }
  if(!customElements.get('pdp-mobile-selector')) customElements.define('pdp-mobile-selector',MobileSelector);

  class StickyCart extends HTMLElement {
    connectedCallback(){
      this.abort=new AbortController();
      const hero=this.closest('.shopify-section--pdp-v2');
      const footer=document.querySelector('.footer');
      const update=()=>{
        const visible=innerWidth>=1000&&hero?.getBoundingClientRect().bottom<=0&&(!footer||footer.getBoundingClientRect().top>=innerHeight);
        this.classList.toggle('is-visible',visible);
        this.inert=!visible;
      };
      this.observer=new ResizeObserver(update);
      if(hero)this.observer.observe(hero);
      window.addEventListener('scroll',update,{passive:true,signal:this.abort.signal});
      window.addEventListener('resize',update,{passive:true,signal:this.abort.signal});
      update();
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
  }
  if(!customElements.get('pdp-sticky-cart'))customElements.define('pdp-sticky-cart',StickyCart);

  class InfoPopover extends HTMLElement {
    connectedCallback(){
      this.abort=new AbortController();
      this.trigger=document.querySelector(`[popovertarget="${CSS.escape(this.id)}"]`);
      const position=()=>{
        if(!this.matches(':popover-open')||!this.trigger)return;
        const anchor=this.trigger.getBoundingClientRect();
        const width=this.offsetWidth, height=this.offsetHeight;
        this.style.left=`${Math.max(16,Math.min(innerWidth-width-16,anchor.right-width))}px`;
        const top=anchor.top>=height+24?anchor.top-height-8:anchor.bottom+8;
        this.style.top=`${Math.max(16,Math.min(innerHeight-height-16,top))}px`;
      };
      this.addEventListener('toggle',()=>{
        const open=this.matches(':popover-open');
        this.trigger?.setAttribute('aria-expanded',String(open));
        if(open)position();
      },{signal:this.abort.signal});
      this.addEventListener('click',event=>{
        if(event.target.closest('[data-popover-close]')){this.hidePopover();this.trigger?.focus({preventScroll:true});}
      },{signal:this.abort.signal});
      document.addEventListener('keydown',event=>{
        if(event.key==='Escape'&&this.matches(':popover-open')){
          event.preventDefault();event.stopPropagation();this.hidePopover();this.trigger?.focus({preventScroll:true});
        }
      },{capture:true,signal:this.abort.signal});
      window.addEventListener('resize',position,{passive:true,signal:this.abort.signal});
      window.addEventListener('scroll',position,{passive:true,signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort();}
  }
  if(!customElements.get('pdp-info-popover'))customElements.define('pdp-info-popover',InfoPopover);

  class PhotoFanPause extends HTMLElement {
    constructor(){super();this.toggle=this.toggle.bind(this);}
    connectedCallback(){this.addEventListener('click',this.toggle);}
    disconnectedCallback(){this.removeEventListener('click',this.toggle);}
    toggle(event){
      const button=event.target.closest('button');
      if(!button||!this.contains(button)) return;
      const paused=button.dataset.paused!=='true';
      button.dataset.paused=String(paused);
      const label=paused?button.dataset.playLabel:button.dataset.pauseLabel;
      button.setAttribute('aria-label',label);
      button.title=label;
    }
  }
  if(!customElements.get('pdp-photo-fan-pause')) customElements.define('pdp-photo-fan-pause',PhotoFanPause);
})();
